module.exports = __webpack_public_path__ + "media/images/metronic/ajax-loading-1a8a5fd0620143a1527140b8b9d08368.gif";